import { InjectionToken } from '@angular/core';

export type AppBrand = 'domo' | 'dib';

export const APP_BRAND = new InjectionToken<AppBrand>('APP_BRAND');
